<template>
  <div ref="searchContainer" class="form-group mb-0">
    <div class="input-group input-group-alternative input-group-merge">
      <div :class="['contentSearch', { 'has-input': isActive && query.length >= 1}]">
        <div class="input-group-prepend">
          <span class="input-group-text">
            <i class="fas fa-search"></i>
          </span>
        </div>
        <input
          v-model="query"@input="debouncedSearch"
          class="form-control input"
          :placeholder="placeHolder" 
          type="text"
          @focus="onFocusState"
          @blur="onBlurState"
          @keydown.up.prevent="highLight(highLightIndex - 1)"
          @keydown.down.prevent="highLight(highLightIndex + 1)"
          @keydown.enter.prevent="selectSuggestion(allItems[highLightIndex])" 
        />
        <button v-if="query" @click="clearSearch" class="buttonClose">×</button>
        <div v-if="isActive && query.length >= 1" ref="dropdown" class="suggestions-dropdown">
          <div v-if="results && Object.keys(results).length">
            <div v-for="(items, category) in results" :key="category">
              <div class="contentCategory">
                <i :class="getIconForCategory(category)"></i>
                {{ category }}
              </div>
              <ul>
                <li v-for="(item, index) in items" 
                  :key="item.path" :class="{ highlighted: getGlobalIndex(category, index) === activeHighLighIndex}" 
                  @mousedown="selectSuggestion(item)"
                  @mouseover="mouseOver(getGlobalIndex(category, index))"
                  @mouseleave="mouseLeave"
                >
                  <i :class="item.icon"></i> {{ item.name }}
                </li>
              </ul>
            </div>
          </div>
          <div v-else-if="isActive && query.length >= 1 && (results || !Object.keys(results).length)" class="no-results">
            Nenhum resultado encontrado
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

export default {
  data() {
    return {
      query: '',
      results: null,
      debouncedSearch: null,
      highLightIndex: -1,
      mouseOverIndex: -1,
      isActive: false,
      placeHolder: 'Pesquisa',
    };
  },
  created() {
    this.debouncedSearch = _.debounce(this.search, 300);
  },
  computed: {
    filteredRoutes() {
      const groups = this.$router.options.groups || {};

      const allRoutes = [
        ...this.$router.options.routes,
        ...Object.values(groups).flatMap(group => group.routes || [])
      ];

      const seenPaths = new Set();

      const validRoutes = allRoutes.filter(route => {
        if (!route || !route.meta) return false;

        if (!this.$currentUser().is_admin && (route.path === "/admin/ppr" || route.path === "/cri/main")) {
          return false;
        }

        if (seenPaths.has(route.path)) return false;

        seenPaths.add(route.path);

        if (route.meta.visibleOnSearch && this.$currentUser().is_admin)   return true;
        if (route.meta.visibleOnSearch)                                   return true;
        if (route.meta.hideFromSidenav && !route.meta.visibleOnSearch)    return false;
        if (route.meta.hideFromSidenavSGV && !route.meta.visibleOnSearch) return false;

        if (this.$currentUser().is_admin && (route.meta.hideFromSidenav || route.meta.hideFromSidenavAdmin)) {
          return false;
        }
        if (route.meta.hideFromSidenav &&  route.meta.visibleOnSearch && !this.$currentUser().is_admin) {
          return false;
        }

        return route.meta.permissions && route.meta.permissions.find(controller => this.$can("any", controller));
      });
      return validRoutes;
    },
    allItems() {
      return Object.values(this.results || {}).flat();
    },
    activeHighLighIndex() {
      return this.mouseOverIndex !== -1 ? this.mouseOverIndex : this.highLightIndex;
    },
  },
  methods: {
    search() {
      if (this.query.length >= 1) {
        this.results = this.filteredRoutes
          .filter(route => route.name && route.name.toLowerCase().includes(this.query.toLowerCase()))
          .reduce((acc, route) => {
            const groupName = route.meta.group;
            const category = groupName ? this.$router.options.groups[groupName].name : 'Outros';
            const icon = groupName ? this.$router.options.groups[groupName].icon : route.meta.icon || '';

            if (!acc[category]) {
              acc[category] = [];
            }
            acc[category].push({
              ...route,
              icon,
            });
            return acc;
          }, {});
      } else {
        this.results = null;
      }
    },
    getIconForCategory(category) {
      const groups = this.$router.options.groups || {};
      const group = Object.values(groups).find(g => g.name === category);
      return group ? group.icon : '';
    },
    selectSuggestion(route) {
      this.$router.push(route.path);
      this.highLightIndex = -1;
      this.mouseOverIndex = -1
      this.placeHolder = route.name
      this.clearSearch()
    },
    clearSearch() {
      this.query = '';
      this.results = null;
      this.highLightIndex = -1;
    },
    onFocusState() {
      this.isActive = true;
    },
    onBlurState() {
      this.isActive = false;
    },
    highLight(index) {
      if (this.mouseOverIndex !== -1) this.highLightIndex = this.mouseOverIndex;
      if (index >= this.allItems.length -1) {
        this.highLightIndex = 0;
      } else if (index < 0 ) {
        this.highLightIndex = this.allItems.length - 1;
      } else {
        this.highLightIndex =  index;
      }

      this.$nextTick(() => {
        this.scrollKeyNavigation()
      });
    },
    getGlobalIndex(category, index) {
      const previousItem = Object.keys(this.results)
      .slice(0, Object.keys(this.results).indexOf(category))
      .reduce((total, key) => total + this.results[key].length, 0);
      return previousItem + index
    },
    scrollKeyNavigation() {
      const dropdown = this.$refs.dropdown
      const highlighted = dropdown.querySelector('.highlighted');

      if (dropdown) {
        const dropdownRect = dropdown.getBoundingClientRect()
        const highlightedRect = highlighted.getBoundingClientRect()

        if (highlightedRect.top <= dropdownRect.top) {
          dropdown.scrollTop -= dropdownRect.top - highlightedRect.top;
        } else if (highlightedRect.bottom >= dropdownRect.bottom) {
          dropdown.scrollTop += highlightedRect.bottom - dropdownRect.bottom;
        } 
      }
    },
    mouseOver(index) {
      this.mouseOverIndex = index
    },
    mouseLeave() {
      this.mouseOverIndex = -1;
    },
  },
};
</script>

<style scoped>
 .suggestions-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: snow;
  border: 1px solid #ddd;
  border-top: none; 
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1); 
  transition: opacity 0.3s ease, transform 0.3s ease;
  transform: translateY(-10px);
}

.suggestions-dropdown ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.suggestions-dropdown li {
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.suggestions-dropdown li:hover,
.suggestions-dropdown li.highlighted {
  background-color: #f1f1f1;
  font-weight: bold;
}

.contentSearch:focus-within .suggestions-dropdown {
  opacity: 1;
  transform: translateY(0);
}

.buttonClose {
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  margin-right: 5px;
  cursor: pointer;
  background-color: transparent;
  color: black;
  outline: none;
  align-items: center;
  display: flex;
}

.buttonClose:hover {
  background-color: rgb(255, 0, 0);
  color: white;
}

.contentSearch {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  width: 100%;
  border-radius: 20px;
  background-color: snow;
  object-fit: cover;
  transition: border-radius 0.3s ease;
}

.contentSearch.has-input {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.navbar-search-light .input-group {
  background-color: transparent;
  border-radius: 0px;
}

.input-group-text {
  border-radius: 20px;
  background-color: transparent;
}

.contentCategory {
  background: #f1f1f1;
  font-size: 18px;
  font-family: inherit;
  font-weight: 600;
  line-height: 1.5;
  color: #32325d;
  padding-left: 5px;
}

.suggestions-dropdown::-webkit-scrollbar {
  width: 8px;
}

.suggestions-dropdown::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 10px;
}

.navbar-search .input-group{
  border-radius: 20px;
  border-radius: 20px;
}

.suggestions-dropdown::-webkit-scrollbar-thumb:hover {
  background-color: #b3b3b3;
}
</style>